import { Collapse } from "@mui/material";
import { InputCheck } from "controls";
import React, { useEffect } from "react";

const ReportAccess = ({ values, setValues }) => {
  useEffect(() => {
    if (!values.id) {
      values.reportAccess
        ? setValues((j) => ({
            ...j,
            report: {
              profitAndLoss: true,
              creditCustomer: true,
              productMovement: true,
              trialBalance: true,
            },
          }))
        : setValues((j) => ({
            ...j,
            report: {
              profitAndLoss: false,
              creditCustomer: false,
              productMovement: false,
              trialBalance: false,
            },
          }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.reportAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setValues((j) => ({
      ...j,
      report: { ...j.report, [name]: checked },
    }));
  };

  return (
    <Collapse in={values.reportAccess || false}>
      <div className="ml-[3px] grid gap-1 mt-[2px] mb-[10px] !uppercase tracking-wider !pl-[10px] border-l-4  border-rounded">
        <InputCheck
          label="Profit and Loss"
          checked={values.report?.profitAndLoss || false}
          name={"profitAndLoss"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Credit Customer"
          checked={values.report?.creditCustomer || false}
          name={"creditCustomer"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Product Movement"
          checked={values.report?.productMovement || false}
          name={"productMovement"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Trial Balance"
          checked={values.report?.trialBalance || false}
          name={"trialBalance"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default ReportAccess;
